/**
 * Decodes the payload segment of a JWT without verifying the signature. The backend verifies
 * tokens; the frontend only reads display/routing hints from its own access token.
 */
export function decodeJwtPayload(token: string): unknown {
  const [, base64Url] = token.split(".");
  if (!base64Url) {
    return null;
  }
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}
